var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalWithButton',{attrs:{"name":"create-voucher","title":"Crear nuevo cupón","button_title":"Crear nuevo cupón"},on:{"cerrar":function($event){return _vm.reset()}}},[_c('Form',{attrs:{"voucher":_vm.voucher},on:{"terminado":function($event){return _vm.crearVoucher()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }